import MegaRubberLogo from "../../assets/mega_rubber_logo.jpeg";
import SupremeLogo from "../../assets/supreme_logo.jpeg";
import VenkraftLogo from "../../assets/Venkraft_paper_mills_logo.jpeg";
import "./clients.css";

const Clients = () => {
    return (
        <div className="clients-container">
            <h2>Clients</h2>
            <div className="logo-container">
                <img src={MegaRubberLogo} alt="Mega Rubber logo"/>
                <img src={SupremeLogo} alt="Supreme logo"/>
                <img src={VenkraftLogo} alt="Venkraft Paper Mills Pvt Ltd logo"/>
            </div>
        </div>
    );
};

export default Clients;